import angular from 'angular';

import './gallery';
import './header';
import './icon';
import './location';
import './video';

(() => {
	angular.module('ahsv', [
		'gallery',
		'header',
		'icon',
		'location',
		'video'
	]);
})();



/** WEBPACK FOOTER **
 ** ./src/js/index.js
 **/